/**
 * ConfigHistoryPage — Standalone page for config version history.
 * Shows all snapshots with detail panel.
 * Supports ?configType=split,bank-accounts to filter by config type.
 */

import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PageHeader } from '@/components/layout/PageHeader';
import { ROUTES } from '@/constants';
import { ConfigHistorySection } from '../../components';

const OPS_TYPES = new Set(['split', 'bank-accounts', 'operational-params']);

export function ConfigHistoryPage() {
  const [searchParams] = useSearchParams();
  const rawFilter = searchParams.get('configType');
  const filterTypes = useMemo(
    () => rawFilter ? rawFilter.split(',').map((t) => t.trim()).filter(Boolean) : null,
    [rawFilter],
  );

  // Detect if all filter types are operational (vs policy)
  const isOpsContext = filterTypes !== null && filterTypes.every((t) => OPS_TYPES.has(t));

  const breadcrumbs = isOpsContext
    ? [
        { label: 'Inicio', path: ROUTES.DASHBOARD },
        { label: 'Operaciones', path: ROUTES.OPS_DEFINITIONS },
        { label: 'Definiciones', path: ROUTES.OPS_DEFINITIONS },
        { label: 'Historial', path: ROUTES.CONFIG_HISTORY },
      ]
    : [
        { label: 'Inicio', path: ROUTES.DASHBOARD },
        { label: 'Configuracion', path: ROUTES.POLICIES },
        { label: 'Historial', path: ROUTES.CONFIG_HISTORY },
      ];

  return (
    <div className="space-y-6">
      <PageHeader
        title={isOpsContext ? 'Historial de Definiciones' : 'Historial de Politicas'}
        subtitle={isOpsContext ? 'Cambios en variables operativas del modulo de credito' : 'Versiones de la configuracion del motor de credito'}
        breadcrumbs={breadcrumbs}
        helpKey="config-history"
      />
      <ConfigHistorySection filterTypes={filterTypes} />
    </div>
  );
}
